import React from 'react';
import ReactLoader from 'react-loader';
import { connect } from 'react-redux'

class LoaderIndicator extends React.Component {
  constructor(props) {
    super(props);
      var options = {
        lines: 20,
        length: 15,
        width: 5,
        radius: 10,
        scale: 1.00,
        corners: 1,
        color: '#2E64F0',
        opacity: 0.25,
        rotate: 0,
        direction: 1,
        speed: 1,
        trail: 60,
        fps: 20,
        zIndex: 2e9,
        top: '50%',
        left: '50%',
        shadow: false,
        hwaccel: false,
        position: 'absolute'
    };
    this.state={loaderOption: options};
  }
  render() {
    return (
              <ReactLoader options={this.state.loaderOption} loaded={this.props.apiexecutionstatus.loading} className="spinner" />
        );
  }
}

const mapStateToProps = (state) => {
  return {
    apiexecutionstatus: state.apiexecutionstatus
  }
}

function mapDispatchToProps(dispatch) {
  return ({
  })
}

export default connect(mapStateToProps, mapDispatchToProps)(LoaderIndicator)